import {Component, ChangeDetectionStrategy} from '@angular/core';
import {FormControl} from '@angular/forms';
import {FormInputComponent, CustomFieldConfig} from '@vendure/admin-ui/core';

@Component({
  selector: 'particulars-component',
  templateUrl: './particulars.component.html',
  styleUrls: ['./particulars.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParticularsComponent implements FormInputComponent<CustomFieldConfig> {
  constructor() {
    setTimeout(() => {
      console.log(this);
      // console.log(this);
    }, 2000);
  }
  isListInput?: boolean | undefined;
  readonly: boolean;
  formControl: FormControl;
  config: CustomFieldConfig;

  ngOnInit() {
    // console.log(this.formControl);
    // console.log(this.config);
  }
}
